import React from "react";

export function RegisterForm({ setIsRegistered }) {
    const [isError, setIsError] = React.useState(false);

    async function handleSubmit(event) {
        setIsError(false);
        event.preventDefault();
        if (event.target.accept.checked === false) {
            alert("Du måste godkänna policy och regler för att kunna registrera dig.");
            return;
        }
        // eslint-disable-next-line no-undef
        if (grecaptcha === undefined) {
            alert("Recaptcha saknas. Vänligen försök igen om en stund.");
            return;
        }
        // eslint-disable-next-line no-undef
        grecaptcha.ready(function () {
            // eslint-disable-next-line no-undef
            grecaptcha.execute('6LcNvIMpAAAAAIPbr1NuhjS8ViIAaoIx9gBVdNqa', { action: 'submit' }).then(async function (token) {
                // Send token to your server for verification together with the user request.
                try {
                    const newRegistration = {
                        name_first: event.target.firstname.value,
                        name_last: event.target.lastname.value,
                        email: event.target.email_event.value,
                        email_ctf: event.target.email_ctf.value,
                        // team: event.target.team.value,
                        tour: false, // event.target.tour.checked,
                        occupation: event.target.occupation.value,
                        gender: event.target.gender.value,
                        age: event.target.age.value,
                        food: event.target.food.value,
                        recaptcha: token,
                    };
                    const response = await fetch("/api/attendees/", {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                        },
                        body: JSON.stringify(newRegistration),
                    });
                    if (response.ok) {
                        const body = await response.json();
                        if (body.status === "accepted") {
                            setIsRegistered(true);
                            return;
                        } else {
                            console.log("Registration failed", body.reason);
                            setIsError(true);
                        }
                    }
                    console.log("Registration failed", response);
                    setIsError(true);
                } catch (error) {
                    console.error("Registration failed", error);
                    setIsError(true);
                }
            });
        });
    }

    return (
        <>
            <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/purecss@3.0.0/build/pure-min.css" integrity="sha384-X38yfunGUhNzHpBaEBsWLO+A0HDYOQi8ufWDkZ0k9e0eXz/tH3II7uKZ9msv++Ls" crossorigin="anonymous"></link>
            {/* 
                <script src="https://www.google.com/recaptcha/enterprise.js?render=6LdoNGIpAAAAAM4xC9NV7GpEG89BpeiNfinQwltT" />
                https://cloud.google.com/recaptcha-enterprise/docs/samples?_ga=2.187659245.-419800409.1706735251
                https://console.cloud.google.com/security/recaptcha/6LdoNGIpAAAAAM4xC9NV7GpEG89BpeiNfinQwltT/integration?authuser=0&project=undutmaning-1706687549626
            */}

            <form id="register-form" className="pure-form pure-form-aligned" action="" onSubmit={handleSubmit}>
                <fieldset className="mono">
                    <div className="pure-control-group">
                        <label htmlFor="firstname">Förnamn</label>
                        <input type="text" id="firstname" placeholder="First Name" required />
                    </div>
                    <div className="pure-control-group">
                        <label htmlFor="lastname">Efternamn</label>
                        <input type="text" id="lastname" placeholder="Last Name" required />
                    </div>
                    <div className="pure-control-group">
                        <label htmlFor="email_event">E-post Event</label>
                        <input type="email" id="email_event" placeholder="Email Address" required />
                    </div>
                    <div className="pure-control-group">
                        <label htmlFor="email_ctf">E-post CTF</label>
                        <input type="email" id="email_ctf" placeholder="Email Address" required />
                    </div>
                    {/* <div className="pure-control-group">
                        <label htmlFor="team">
                            <abbr title="Valfritt">Lag CTF</abbr>
                        </label>
                        <input type="text" id="team" placeholder="Team Name" />
                    </div> */}
                    <div className="pure-control-group">
                        <label htmlFor="occupation">Sysselsättning</label>
                        <select id="occupation" required>
                            <option value="">Välj...</option>
                            <option value="student">Student</option>
                            <option value="working">Jobbar</option>
                            <option value="other">Annat</option>
                        </select>
                    </div>
                    <div className="pure-control-group">
                        <label htmlFor="gender">Kön</label>
                        <select id="gender" required>
                            <option value="">Välj...</option>
                            <option value="male">Man</option>
                            <option value="female">Kvinna</option>
                            <option value="other">Annat</option>
                        </select>
                    </div>
                    <div className="pure-control-group">
                        <label htmlFor="age">Ålder</label>
                        <input type="number" id="age" placeholder="Age" min="0" max="120" required />
                    </div>
                    <div className="pure-control-group">
                        <label htmlFor="food">Matpreferenser</label>
                        <select id="food" required>
                            <option value="none">Inga</option>
                            <option value="vegetarian">Vegetarisk</option>
                            <option value="vegan">Vegan</option>
                            <option value="lactose">Laktosfri</option>
                            <option value="gluten">Glutenfri</option>
                        </select>
                    </div>
                    <span className="pure-form-message-inline text-justify" style={{ color: "var(--color-lime)" }}>
                        <br />
                        <b>OBS!</b>{" "}
                        Om du vill bli kontaktad på en annan e-postadress än den du plannerar att använda för att registrera dig på CTF tävlingen,
                        skriv in den i fältet <code>'E-post Event'</code>. Kom ihåg att registrering till CTF tävlingen görs på <a href="https://undutmaning.ctfd.io">undutmaning.ctfd.io</a>.
                    </span>
                    <div className="pure-controls">
                        {/* <label htmlFor="tour" className="pure-checkbox">
                            <input type="checkbox" id="tour" /> Jag vill ha en guidad tur på museet.
                        </label> */}
                        <label htmlFor="accept" className="pure-checkbox">
                            <input type="checkbox" id="accept" required /> Jag godkänner <a href="/rules">policy och regler</a>.
                        </label>
                        <button type="submit" className="pure-button pure-button-primary">Submit</button>
                    </div>
                    {isError && (
                        <span className="pure-form-message-inline text-justify" style={{ color: "red" }}>
                            <br />
                            <b>PROBLEM:</b>{" "}
                            Registreringen misslyckades. Vänligen försök igen. <br />
                            Om problemet kvarstår, kontakta någon av administatörerna med rollen "Undmin" på Discord.
                        </span>
                    )}
                </fieldset>
            </form>
        </>
    );
}
